import React from "react";

const MessageIcon = ({ cls }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_3304_38520)">
        <path
          d="M16 7.49789C15.9036 5.9379 15.3528 4.44023 14.4155 3.1895C13.4781 1.93878 12.1953 0.989683 10.7251 0.459218C9.25494 -0.0712477 7.66166 -0.15989 6.1417 0.204218C4.62174 0.568326 3.24155 1.36927 2.17129 2.5083C1.10103 3.64733 0.387483 5.07466 0.118617 6.61433C-0.150248 8.15399 0.0373205 9.73868 0.6582 11.173C1.27908 12.6074 2.30613 13.8287 3.61273 14.6864C4.91933 15.5441 6.44836 16.0007 8.01132 15.9999H12.6667C13.5504 15.999 14.3978 15.6475 15.0227 15.0226C15.6476 14.3977 15.9991 13.5503 16 12.6666V7.49789ZM14.6667 12.6666C14.6667 13.197 14.4559 13.7057 14.0809 14.0808C13.7058 14.4558 13.1971 14.6666 12.6667 14.6666H8.01132C7.07061 14.6661 6.14055 14.4674 5.28179 14.0834C4.42302 13.6994 3.65484 13.1387 3.02732 12.4379C2.39677 11.7374 1.92328 10.9102 1.63859 10.0117C1.35389 9.11329 1.26459 8.16435 1.37666 7.22855C1.55361 5.75252 2.21678 4.37735 3.26162 3.31984C4.30645 2.26233 5.67352 1.58263 7.14732 1.38789C7.43481 1.35185 7.72425 1.3336 8.01399 1.33322C9.56764 1.32898 11.0732 1.87182 12.2667 2.86655C12.9637 3.44585 13.5358 4.16066 13.9483 4.96764C14.3609 5.77463 14.6053 6.65698 14.6667 7.56122V12.6666Z"
          fill="currentColor"
        />
        <path
          d="M5.33332 6.00008H7.99999C8.1768 6.00008 8.34637 5.92984 8.47139 5.80482C8.59642 5.67979 8.66666 5.51023 8.66666 5.33341C8.66666 5.1566 8.59642 4.98703 8.47139 4.86201C8.34637 4.73699 8.1768 4.66675 7.99999 4.66675H5.33332C5.15651 4.66675 4.98694 4.73699 4.86192 4.86201C4.73689 4.98703 4.66666 5.1566 4.66666 5.33341C4.66666 5.51023 4.73689 5.67979 4.86192 5.80482C4.98694 5.92984 5.15651 6.00008 5.33332 6.00008Z"
          fill="currentColor"
        />
        <path
          d="M10.6667 7.33325H5.33332C5.15651 7.33325 4.98694 7.40349 4.86192 7.52851C4.73689 7.65354 4.66666 7.82311 4.66666 7.99992C4.66666 8.17673 4.73689 8.3463 4.86192 8.47132C4.98694 8.59635 5.15651 8.66659 5.33332 8.66659H10.6667C10.8435 8.66659 11.013 8.59635 11.1381 8.47132C11.2631 8.3463 11.3333 8.17673 11.3333 7.99992C11.3333 7.82311 11.2631 7.65354 11.1381 7.52851C11.013 7.40349 10.8435 7.33325 10.6667 7.33325Z"
          fill="currentColor"
        />
        <path
          d="M10.6667 10H5.33332C5.15651 10 4.98694 10.0702 4.86192 10.1953C4.73689 10.3203 4.66666 10.4899 4.66666 10.6667C4.66666 10.8435 4.73689 11.013 4.86192 11.1381C4.98694 11.2631 5.15651 11.3333 5.33332 11.3333H10.6667C10.8435 11.3333 11.013 11.2631 11.1381 11.1381C11.2631 11.013 11.3333 10.8435 11.3333 10.6667C11.3333 10.4899 11.2631 10.3203 11.1381 10.1953C11.013 10.0702 10.8435 10 10.6667 10Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_38520">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MessageIcon;
